import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { Logo } from "@/components/Logo";
import { LazyNetwork } from "@/components/fx/LazyNetwork";
import { openPreferences } from "@/lib/consent";
import B from "@/content/business.json";

const lk = "inline-flex min-h-[44px] items-center hover:text-white hover:underline underline-offset-4";

export const Footer = () => (
  <footer data-theme="dark" className="rl-grain relative overflow-hidden bg-[#13352F] pb-28 pt-20 text-white lg:pb-14" data-testid="site-footer">
    <LazyNetwork density={20000} amberRatio={0.04} className="opacity-50" />
    <div className="rl-container relative">
      <Link to="/" aria-label="Recruiting Lab, vai alla home" className="inline-flex min-h-[44px] items-center"><Logo light size={40} /></Link>
      <p className="rl-display mt-10 max-w-[900px] text-[clamp(2.2rem,6vw,5.6rem)]" data-testid="footer-tagline">
        La persona giusta, <span className="text-[#BCE3D6]">con metodo.</span>
      </p>
      <p className="mt-6 max-w-[620px] text-lg text-white/85" data-testid="footer-claim">
        Tu pensi a fare impresa. Alla persona giusta pensiamo noi.
      </p>
      <div className="mt-16 grid gap-8 border-t border-white/15 pt-8 text-[14px] text-white/80 md:grid-cols-4">
        <address className="space-y-1 not-italic" data-testid="footer-company">
          <p className="font-medium text-white">{B.nome}</p>
          <p>{B.via}, {B.cap} {B.citta} ({B.prov})</p>
          <a href={`tel:${B.telHref}`} className={lk} data-testid="footer-phone">Tel. {B.tel}</a><br />
          <a href={`mailto:${B.email}`} className={lk} data-testid="footer-email">{B.email}</a>
          <p className="font-mono-data text-[12px]" data-testid="footer-piva">{B.piva ? `P.IVA ${B.piva}` : "P.IVA in arrivo"}</p>
          <div className="flex gap-1 pt-1">
            <a href={B.instagram} target="_blank" rel="noopener noreferrer" aria-label="Recruiting Lab su Instagram" className="inline-flex h-11 w-11 items-center justify-center rounded-full hover:bg-white/10" data-testid="footer-instagram"><Instagram size={18} /></a>
            <a href={B.facebook} target="_blank" rel="noopener noreferrer" aria-label="Recruiting Lab su Facebook" className="inline-flex h-11 w-11 items-center justify-center rounded-full hover:bg-white/10" data-testid="footer-facebook"><Facebook size={18} /></a>
          </div>
        </address>
        <nav aria-label="Approfondimenti" className="flex flex-col">
          <Link to="/ruoli" className={lk} data-testid="footer-ruoli-link">Ruoli</Link>
          <Link to="/settori" className={lk} data-testid="footer-settori-link">Settori</Link>
          <Link to="/guide" className={lk} data-testid="footer-guide-link">Guide</Link>
        </nav>
        <nav aria-label="Link legali" className="flex flex-col">
          <Link to="/privacy" className={lk} data-testid="footer-privacy-link">Informativa privacy</Link>
          <Link to="/cookie" className={lk} data-testid="footer-cookie-link">Cookie policy</Link>
          <button type="button" onClick={openPreferences} className={`${lk} text-left`} data-testid="footer-cookie-prefs">Preferenze cookie</button>
        </nav>
        <p className="font-mono-data text-[12px] uppercase tracking-[0.14em] text-white/60 md:text-right">© {new Date().getFullYear()} Recruiting Lab Italia</p>
      </div>
    </div>
  </footer>
);
